<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Beranda' },

    extends: View,

    mixins: [
      LoadSections([
        'slider',
        'products',
        'features',
        'testimony',
        'affiliates',
        'news-latest',
        'awards',
        'newsletter',
        'organization',
        'info',
        'certificate',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
      ano: {
        type: String,
        default: '',
      },
    },
  }
</script>
